import { styled } from '@/stitches.config';
import { Box, Link, PageTitle } from '@base-app';
import { ReactComponent as BackIcon } from '@assets/icons/arrow-left.svg';

export const PageStyled = styled(Box, {
  maxWidth: '$layoutMaxWidth',
  margin: 'auto',
  marginTop: '$4',
  padding: '$3',
});

export const BackUrlStyled = styled(Box, { display: 'flex' });

export const LinkStyled = styled(Link, { display: 'inline-flex', alignItems: 'center' });

export const PageTitleStyled = styled(PageTitle, { textAlign: 'left' });

export const BackIconStyled = styled(BackIcon, {
  width: '$4',
  height: '$4',
  marginRight: '$1',
});
